import { Component, OnDestroy, OnInit, ElementRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { GuidaAllertaService } from './guida-allerta.service';
import { comuniData } from './comuni-data-completo-tipizzato-escaped';
import { CustomHeaderComponent } from './custom-header/custom-header.component';
import { FilterComponent } from 'ag-grid-community/dist/lib/components/framework/componentTypes';


@Component({
  selector: 'guida-allerta',
  templateUrl: './guida-allerta.component.html',
  styleUrls: ['./guida-allerta.component.scss'],
  providers: [GuidaAllertaService]

})
export class GuidaAllertaComponent implements OnInit, OnDestroy {

  customLocaleText = {
    noRowsToShow: 'Nessun dato disponibile',
    loadingOoo: 'Caricamento in corso...',
    page: 'Pagina',
    of: 'di',
    more: 'Altro',
    to: 'a'
  };

  modelList = [];
  titoliModelList = [
    "Stato del Cielo",
    "Mare",
    "Vento",
    "Fenomeni Significativi"
  ];

  gridOptions: any;
  data = [];
  selectedZone = "*";

  @ViewChild('myObject') objectRef: ElementRef;

  srcImgZona: any[] = [
    {
      nome: "GRIGIO",
      codice: "#CCC"
    },
    {
      nome: "GRIGIO",
      codice: "#CCC"
    },
    {
      nome: "GRIGIO",
      codice: "#CCC"
    },
    {
      nome: "GRIGIO",
      codice: "#CCC"
    },
    {
      nome: "GRIGIO",
      codice: "#CCC"
    },
    {
      nome: "GRIGIO",
      codice: "#CCC"
    },
    {
      nome: "GRIGIO",
      codice: "#CCC"
    },
    {
      nome: "GRIGIO",
      codice: "#CCC"
    }
  ];

  constructor(private restService: GuidaAllertaService, private modalService: NgbModal, private _sanitizer: DomSanitizer) { }

  precipitazioni_verde: string = "Precipitazioni Verde fenomeni ed effetti ingenti ed estesi.";
  precipitazioni_gialla: string = "Precipitazioni Gialla fenomeni ed effetti ingenti ed estesi.";
  precipitazioni_arancione: string = "Precipitazioni Arancione fenomeni ed effetti ingenti ed estesi.";
  precipitazioni_rossa: string = "Precipitazioni Rossa fenomeni ed effetti ingenti ed estesi.";

  temporali_verde: string = "Temporali Verde fenomeni ed effetti ingenti ed estesi.";
  temporali_gialla: string = "Temporali Gialla fenomeni ed effetti ingenti ed estesi.";
  temporali_arancione: string = "Temporali Arancione fenomeni ed effetti ingenti ed estesi.";
  temporali_rossa: string = "Temporali Rossa fenomeni ed effetti ingenti ed estesi.";

  vento_verde: string = "Vento Verde fenomeni ed effetti ingenti ed estesi.";
  vento_gialla: string = "Vento Gialla fenomeni ed effetti ingenti ed estesi.";
  vento_arancione: string = "Vento Arancione fenomeni ed effetti ingenti ed estesi.";
  vento_rossa: string = "Vento Rossa fenomeni ed effetti ingenti ed estesi.";

  mare_verde: string = "Mare Verde fenomeni ed effetti ingenti ed estesi.";
  mare_gialla: string = "Mare Gialla fenomeni ed effetti ingenti ed estesi.";
  mare_arancione: string = "Mare Arancione fenomeni ed effetti ingenti ed estesi.";
  mare_rossa: string = "Mare Rossa fenomeni ed effetti ingenti ed estesi.";

  neve_verde: string = "Neve Verde fenomeni ed effetti ingenti ed estesi.";
  neve_gialla: string = "Neve Gialla fenomeni ed effetti ingenti ed estesi.";
  neve_arancione: string = "Neve Arancione fenomeni ed effetti ingenti ed estesi.";
  neve_rossa: string = "Neve Rossa fenomeni ed effetti ingenti ed estesi.";

  anomalia_temperature_verde: string = "Anomalia Temperature Verde fenomeni ed effetti ingenti ed estesi.";
  anomalia_temperature_gialla: string = "Anomalia Temperature Gialla fenomeni ed effetti ingenti ed estesi.";
  anomalia_temperature_arancione: string = "Anomalia Temperature Arancione fenomeni ed effetti ingenti ed estesi.";
  anomalia_temperature_rossa: string = "Anomalia Temperature Rossa fenomeni ed effetti ingenti ed estesi.";

  // onResize(event) {

  //   var larg = Math.round(((event.target.innerWidth)/100)*95) + "px";
  //   if(event.target.innerWidth < 1198){
  //     var legenda = document.getElementById('legendaAllertaGuida').style.width = ""+larg+"";

  //   }else{
  //     var legenda = document.getElementById('legendaAllertaGuida').style.width = "";
  //   }

  // }


  // ngAfterViewInit() {

  //   var larg = Math.round(((window.innerWidth)/100)*95) + "px";
  //   if(window.innerWidth < 1198){
  //     var legenda3 = document.getElementById('legendaAllertaGuida').style.width = ""+larg+"";

  //   }else{
  //     var legenda3 = document.getElementById('legendaAllertaGuida').style.width = "";
  //   }

  // }

  ngOnInit() {

    this.restService.selectAll().then(
      res => {

        var modelAggregate = [];

        for (var k in res) {

          var tipo = res[k].tipoAsset;

          var model = modelAggregate[tipo];
          if (!model) {

            //console.log("model non esiste per tipo ["+tipo+"]");
            model = {

              tipoAsset: tipo,
              assets: []

            };

          }

          var descrizione = res[k].descrizione;
          var imgUrl = res[k].imgUrl;

          model.assets.push({
            descrizione: descrizione,
            imgUrl: imgUrl
          });

          modelAggregate[tipo] = model;

        }

        var orderedList = [];

        modelAggregate.forEach(e => orderedList.push(e));

        this.modelList = orderedList; // modelAggregate;

      }
    )
    this.setupAgSettings();
    // this.caricaComuni("*");


    //this.creaSvgMap();

  };

  ngOnDestroy() {

  };

  getWindowWidth() {
    if (window.innerWidth > 1199) return true;
    else
      return false;
  };

  setupAgSettings() {
    let ref = this;

    ref.gridOptions = {
      onGridReady: (params: any) => this.onGridReady(params),
      animateRows: true,
      pagination: true,
      paginationPageSize: 30,
      enableCellTextSelection: true,
      rowHeight: 50,
      defaultColDef: {
        editable: false,
        filter: true,
        sortable: true,
        flex: 1,
        minWidth: 100,
        cellStyle: { display: "flex", alignItems: "center", justifyContent: "center" },
        cellClass: "fontClamp",
        headerClass: "header-mappa",
        suppressMenu: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filterParams: { suppressAndOrCondition: true },
      },
      rowStyle: {
        background: "#fff",
        color: "#000",
      },
      columnDefs: [
        {
          headerName: this.selectedZone != "*" ? `Comune (Zona ${this.selectedZone})` : "Comuni (Tutti)",
          field: "comune",
          filter: "agTextColumnFilter",
          floatingFilter: true,
          headerComponentFramework: CustomHeaderComponent,
          headerComponentParams: {
            onButtonClick: () => this.caricaComuni("*"),
          },
          cellClass: "cell-text-comuni"
        },
      ],
      onCellClicked: (event: any) => {
        if (event.column.getColId() === "comune" && event.data && this.selectedZone == "*") {
          this.cambiaColoreClick(event.data.zonaId); 
        }
      },
      onCellMouseOver: (event: any) => {
        if (event.column.getColId() === "comune" && event.data && this.selectedZone == "*") {
          this.cambiaColoreHover(event.data.zonaId);          
        }
      },
      onCellMouseOut: (event: any) => {
        if (event.column.getColId() === "comune" && event.data && this.selectedZone == "*") {
          this.cambiaColoreOuter(event.data.zonaId);          
        }
      }
    };
  }

  caricaComuni(zonaId): void {
    this.selectedZone = zonaId;
  
    // 🔁 Reset filtro se "Tutti"
    if (this.selectedZone === "*") {
      if (this.gridOptions?.api) {
        // Resetta il filtro logico
        const comuneFilter = this.gridOptions.api.getFilterInstance('comune');
        comuneFilter?.setModel(null);
        this.gridOptions.api.onFilterChanged();
  
        // 🔄 Forza l'aggiornamento visuale del floating filter (input UI)
        const colDef = this.gridOptions.columnApi.getColumnState().find(c => c.colId === 'comune');
        if (colDef) {
          colDef.floatingFilter = false;
          this.gridOptions.api.setColumnDefs(this.gridOptions.columnDefs); // Ri-applica le colonne per forzare la rimozione del filtro
          colDef.floatingFilter = true;
          setTimeout(() => this.gridOptions.api.refreshHeader(), 0); // Re-render floating filters
        }
      }
  
      // Ricarica tutti i comuni
      this.data = comuniData;
      this.cambiaColoreClick(zonaId);
    } else {
      // Filtro per zona
      this.data = comuniData.filter(comune => comune.zonaId == zonaId);
      this.cambiaColoreClick(zonaId);
    }
  
    // 🔁 Aggiorna l'header dinamico
    const newColumnDefs = [
      {
        headerName: this.selectedZone !== "*" ? `Comune (Zona ${this.selectedZone})` : "Comuni (Tutti)",
        field: "comune",
        filter: "agTextColumnFilter",
        floatingFilter: true,
        headerComponentFramework: CustomHeaderComponent,
        headerComponentParams: {
          onButtonClick: () => this.caricaComuni("*"),
        },
        cellClass: "cell-text-comuni"
      },
    ];
  
    if (this.gridOptions?.api) {
      this.gridOptions.api.setColumnDefs(newColumnDefs);
      this.gridOptions.api.refreshHeader();
    }
  }
  
  

  // openModal(livelloHtml:any) {

  //   const activeModal = this.modalService.open(ModalComponent, { size: 'lg', container: 'nb-layout' });

  //   activeModal.componentInstance.modalHeader = 'Large Modal';
  //   activeModal.componentInstance.title = "Titolo Legenda";
  //   var strHTML = 
  //   `<div style="font-family: roboto;">
  //     <p style=" text-align: justify; margin: auto; padding: 20px;">
  //     ` + livelloHtml + `
  //     </p>
  //   </div>`;

  //   activeModal.componentInstance.htmlToRender = strHTML; //this._sanitizer.bypassSecurityTrustHtml(strHTML);
  //   activeModal.componentInstance.activeModal = activeModal;

  // }

  cambiaColoreHover(level) {
    // var level = <HTMLElement>ev.target.parentElement.lastChild.innerHTML;
    let pattoarr = document.getElementsByClassName('patto' + level) as HTMLCollectionOf<HTMLElement>;;
    for (let i = 0; i < pattoarr.length; i++) {
      pattoarr[i].classList.add('greenFill');
    }
  }

  cambiaColoreOuter(level) {
    // var level = <HTMLElement>ev.target.parentElement.lastChild.innerHTML;
    let pattoarr = document.getElementsByClassName('patto' + level) as HTMLCollectionOf<HTMLElement>;;
    for (let i = 0; i < pattoarr.length; i++) {
      pattoarr[i].classList.remove('greenFill');
    }
  }

  cambiaColoreClick(level){
    let pattoarrBefore = document.getElementsByClassName('overEffect') as HTMLCollectionOf<HTMLElement>;;
    for (let i = 0; i < pattoarrBefore.length; i++) {
      pattoarrBefore[i].classList.remove('greenFill');
    }

    let pattoarr = document.getElementsByClassName('patto' + level) as HTMLCollectionOf<HTMLElement>;;
    for (let i = 0; i < pattoarr.length; i++) {
      pattoarr[i].classList.add('greenFill');
    }
  }

  onGridReady(params: any) {
    this.gridOptions.api = params.api;
    this.gridOptions.columnApi = params.columnApi;
  
    // Ora che abbiamo la API, possiamo caricare i comuni in sicurezza
    this.caricaComuni("*");
  }

}




